import { render, staticRenderFns } from "./PlatformConnectPage.vue?vue&type=template&id=5ea9930f&scoped=true"
import script from "./PlatformConnectPage.vue?vue&type=script&lang=js"
export * from "./PlatformConnectPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformConnectPage.vue?vue&type=style&index=0&id=5ea9930f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9930f",
  null
  
)

export default component.exports